import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useRouteSync } from '../../bridge/useRouteSync';
import { FLOW_ID } from './shared';
import { PendingList } from './steps/PendingList';
import { ApprovePayment } from './steps/ApprovePayment';

/**
 * card-payment-sca — 3DS SCA challenge inbox.
 *
 * A master → detail pair (a pending list and a per-item approve screen), NOT
 * an ordered wizard: no Next button, no progress, no per-step field
 * validation. Per LESSONS § "NO force StepWizard on flows with independent
 * entry points", the flow uses a plain `<Routes>`; navigation between the two
 * screens is in-app (row click / Back). `readiness: 'manual'` — both screens
 * fetch on entry behind a spinner and signal readiness themselves
 * (see flows/index.ts and PRD § 3 / § 11 O-2).
 *
 * No `FormProvider`: there are no RHF fields (PRD § 4 / § 6).
 */
export const CardPaymentScaFlow: React.FC = () => {
  // Mirror the master→detail route into the host URL bar so a specific payment
  // is deep-linkable (`/flow/card-payment-sca/approve-payment/<id>`).
  useRouteSync(FLOW_ID);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="pending" replace />} />
      <Route path="pending" element={<PendingList />} />
      <Route path="approve-payment/:notificationId" element={<ApprovePayment />} />
      <Route path="*" element={<Navigate to="pending" replace />} />
    </Routes>
  );
};

export default CardPaymentScaFlow;
